import { withStyles } from '@material-ui/core';

import SizesList from './component';
import styles from './styles';

export default withStyles(styles)(SizesList);
